import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SnippetsTwoToneSvg from "@ant-design/icons-svg/es/asn/SnippetsTwoTone";
import AntdIcon from "../components/AntdIcon";
var SnippetsTwoTone = function SnippetsTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SnippetsTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SnippetsTwoTone.displayName = 'SnippetsTwoTone';
}
export default /*#__PURE__*/React.forwardRef(SnippetsTwoTone);